import {useMutation} from 'react-query';

import {addComments} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const useAddComments = (refetchAllComments: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IAddComments) => {
      return addComments(payload);
    },
    onSuccess: data => {
      refetchAllComments();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default useAddComments;
